export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11201.59886dd6.jpg";